import { ArrowDownOutlined, ArrowUpOutlined, FieldNumberOutlined } from '@ant-design/icons';
import { Col, Row, Statistic } from 'antd';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { RowBg } from '../../../../styles';
import { formatPLN } from '../../../../utils/helpers/formatNumber';

const ImpStatsMoney = ({
  sumOfInterestData,
  sumOfPaymentData,
  numberOfImports,
}:{
  sumOfInterestData: number
  sumOfPaymentData: number
  numberOfImports: number,
}) => {
  const { t } = useTranslation();
  return (
    <RowBg justify='space-around'>
      <Col span={8}>
        <Row justify="center">
          <Statistic
            title={t('ImpStatsMoney.claims')}
            value={formatPLN(sumOfInterestData)}
            prefix={<ArrowUpOutlined />}
          />
        </Row>
      </Col>
      <Col span={8}>
        <Row justify="center">
          <Statistic
            title={t('ImpStatsMoney.payments')}
            value={formatPLN(sumOfPaymentData)}
            prefix={<ArrowDownOutlined />}
          />
        </Row>
      </Col>
      <Col span={8}>
        <Row justify="center">
          <Statistic
            title={t('ImpStatsMoney.docs')}
            value={numberOfImports}
            prefix={<FieldNumberOutlined />}
          />
        </Row>
      </Col>
    </RowBg>
  );
};

export default ImpStatsMoney;